import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { PreferredStoreService } from "@services/preferredStore.service";

import { useThunkDispatch } from "@redux/dispatcher";
import { UpdateCustomerMapper } from "@redux/modules/api/data/customer/customer.mapper";
import * as CustomerModule from "@redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type Props = {
    storeId: string;
};

const PreferredStoreButton = ({ storeId }: Props) => {
    const customer = useSelector(CustomerSelectors.getCustomer);
    const dispatch = useThunkDispatch();
    const { t } = useGranite();
    const [isPreferredStore, setIsPreferredStore] = useState(false);

    useEffect(() => {
        dispatch(CustomerModule.load());
        setIsPreferredStore(
            PreferredStoreService.getPreferredStoreOfTheUser() ===
                String(storeId),
        );
    }, []);

    const onClickHandler = () => {
        isPreferredStore
            ? PreferredStoreService.removePreferredStoreOfTheUser()
            : PreferredStoreService.setPreferredStoreOfTheUser(storeId);

        updateCustomer(!isPreferredStore);
        setIsPreferredStore(!isPreferredStore);
    };

    const updateCustomer = (addStore: boolean) => {
        if (customer) {
            const favouriteStoreId = addStore ? storeId : null;

            dispatch(
                CustomerModule.updateFromData({
                    ...customer,
                    favouriteStoreId,
                }),
            );
        }
    };

    const icon = isPreferredStore ? "check-square" : "stop";

    return (
        <Button type="button" onClick={onClickHandler} color="gray">
            <Fragment>
                <i className={`las la-${icon} mr-2`} />
                {t(`store.detail.preferredStore.button.${!!isPreferredStore}`)}
            </Fragment>
        </Button>
    );
};

export { PreferredStoreButton };
